export default "__VITE_ASSET__BHky41$H__"